
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto/[slug]/[id]",
      function () {
        return require("private-next-pages/auto/[slug]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto/[slug]/[id]"])
      });
    }
  